import './solid.js';
import './regular.js';
import './light.js';
import './sharp_solid.js';

import { getIcon, getLayeredIcon } from './get_icon';
import { getCountryIcon } from './flags';

const icon = {
	getIcon,
	getLayeredIcon, 
	getCountryIcon
}

export {
	icon
}
